import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as Sentry from "@sentry/browser";

@Injectable({
  providedIn: "root",
})
export class SentryContextService {
  constructor(private activatedRoute: ActivatedRoute) {
    this.initURLParamsCapture();
    this.initCookiesCapture();
  }


  // Since configureScope is deprecated in Sentry, we can achieve the same functionality using Sentry.setUser

  // Captures the user ID and sets it in Sentry's context
  setUserContext(userId: string) {
    // Sentry.configureScope((scope) => {
    // });
    Sentry.setUser({ id: userId });
  }

  // Initializes capturing of URL parameters
  private initURLParamsCapture() {
    this.activatedRoute.queryParams.subscribe((params) => {
      // Sentry.configureScope((scope) => {
      // });
      Sentry.setContext("url_params", params);
    });
  }

  // Initializes capturing of cookies
  private initCookiesCapture() {
    const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
      const [key, value] = cookie.split("=");
      acc[key] = value;
      return acc;
    }, {});

    // Sentry.configureScope((scope) => {
    // });
    Sentry.setContext("cookies", cookies);
  }

  // Call this method to clear user context on user logout
  clearUserContext() {
    // Sentry.configureScope((scope) => scope.setUser(null));
    Sentry.setUser(null)
  }
}
